import styled from '../../node_modules/.pnpm/@linaria_react@3.0.0-beta.15_react@17.0.2/node_modules/@linaria/react/esm/styled.js';
import { getPresets } from '@indriver/vandermeer';
import preset from './preset.js';

var style = getPresets(preset, {
  shadow: 'shadow'
});
var Box = /*#__PURE__*/styled("div")({
  name: "Box",
  class: "bshfgbs",
  vars: {
    "bshfgbs-0": [style.shadow]
  }
});

export { Box };


require('../../../styles-linaria/bottom-sheet/bottom-sheet-body/bottom-sheet-body.styles.css');
